import { default as Mui4Popover } from '@material-ui/core/Popover'
import { default as Mui5Popover, PopoverProps as Mui5PopoverProps } from '@mui/material/Popover'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

type MuiPopoverOnEntered = NonNullable<Mui5PopoverProps['TransitionProps']>['onEntered']

export enum OsPopoverVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis
}

export type TogglePopoverProps = Omit<Mui5PopoverProps, 'classes'> & {
  onEntered?: MuiPopoverOnEntered
}

export const Popover = forwardRef<HTMLDivElement, TogglePopoverProps>((props, ref) => {
  const { onEntered, TransitionProps, ...rest } = props
  const version = useComponentVersion('popover')
  switch (version) {
    case OsPopoverVersion.V2:
      return <Mui5Popover ref={ref} TransitionProps={{ ...TransitionProps, onEntered }} {...rest} />
    default:
      //@ts-ignore TODO: fix this ref typing issue
      return <Mui4Popover ref={ref} {...props} />
  }
})
